<template>
	
	<!-- 20260317 -- Copilot (Claude Sonnet 4.6) -- Kanban columns fill viewport height -->
	<div class="kanban-board">

		<b-row class="kanban-board-row" style="display:flex; flex-wrap: nowrap; overflow-x:auto">
			<b-col
				v-for="(column, columnIndex) in columnData"
				:key="columnIndex"
				@drop="dropTask($event, columnIndex)"
				@dragover.prevent
				@dragenter.prevent
				cols="12"
				md="4"
			>
				<!-- 20260317 -- Copilot (Claude Sonnet 4.6) -- Plain HTML avoids double .card-body nesting from b-card+b-card-body -->
				<div
					class="card kanban-column-card"
					:style="{ 'background-color': columnIndex % 2 == 0 ? '#F8F8FF' : '#FFFFFF' }"
				>
					<div class="kanban-column-header">{{ column.name }}</div>
					<div class="kanban-details">
						<TaskCard
							v-for="(task, TaskTableIndex) in column.data"
							:key="task.id"
							:index="TaskTableIndex"
							:advancedFilter="getAdvancedFilter(column.item)"
							:columnIndex="columnIndex"
							:rowIndex="TaskTableIndex"
							:task="task"
							:groupField="columnField"
							:childrenExpanded="expanded"
							:detailExpanded="expanded"
							@createChild:task="addChildTask"
							@delete:task="deleteTask"
							@drag:task="dragTask"
							@dragOver:task="dragOverTask"
							@message:task="makeToast"
							class="mb-1"
						/>
					</div>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import TaskCard from '@/components/blocks/TaskCard.vue'

import taskOps from '@/mixins/taskOps'
import genericOps from '@/mixins/genericOps'

export default {
	name: 'TaskDropZone',
	components: {
		TaskCard,
	},

	mixins: [taskOps, genericOps],
	props: {
		columnField: {
			type: String,
			default: 'priority',
		},
		tasks: {
			type: Array,
			default: function() {
				return this.$store.getters.getTasks
			}
		}
	},
	data() {
		return {
			columnData: [],
			columnMap: {},
			expanded: false,
			expandedIcon: 'arrows-expand',
			lastStackRank: 0,
			lastTaskDraggedOver: {},
			taskBeingDragged: {},			
		}
	},
	mounted() {
		this.prepareColumns()
		this.prepareTasks()
	},
	computed: {
		localTasks: {
			get: function() {
				return this.tasks
			},
			set: function(updatedTasks) {
				
				this.$store.dispatch('setTasks', updatedTasks)
			},
		},
	},
	watch: {
		columnField: function (val) {
			this.prepareColumns()
			this.prepareTasks()
		},
		tasks: function(val) {
			// 20200808 -- ZWS -- Seems odd that this watcher is needed.  Perhaps I'm not doing something
			// to make this prop reactive?
			this.prepareTasks()
		}
	},
	methods: {
		addChildTask(parentTask) {
			//Object.assign(this.task, {})

			if (typeof parent !== 'undefined' && parentTask !== null) {
				this.$set(this.task, 'parent', parentTask._id)
				this.$set(this.task, 'parentTask', parentTask)
			}

			////console.log('\n\nTasks.addChildTask passing localTask = ' + JSON.stringify(this.task))

			this.$bvModal.show('taskModal')
		},
		dragOverTask(details) {
			
			//console.log('TaskCard dragging over = ' + JSON.stringify(details))

			if(this.taskBeingDragged._id != details.task._id) {

				this.lastTaskDraggedOver.columnIndex = details.columnIndex
				this.lastTaskDraggedOver.rowIndex = details.rowIndex
				this.lastTaskDraggedOver.task = details.task

			}

			
		
		},
		dragTask(details) {
			//console.log('TaskCard dragging = ' + JSON.stringify(details))
			this.taskBeingDragged.columnIndex = details.columnIndex
			this.taskBeingDragged.rowIndex = details.rowIndex
			this.taskBeingDragged.task = details.task
		},
		async dropTask(event, index) {
			
			console.log('Moving ' + this.taskBeingDragged.task.title 
				+ ' from [' + 
				+ this.taskBeingDragged.columnIndex + ', ' + this.taskBeingDragged.rowIndex
				+ '] to ['
				+ index + ', ' + this.lastTaskDraggedOver.rowIndex
				+ ']'
				)

			// Remove task from original column if the task dragged from one column to another
			if(index != this.taskBeingDragged.columnIndex) {
				
				let tempData = this.columnData[this.taskBeingDragged.columnIndex]
				tempData.data.splice(this.taskBeingDragged.rowIndex, 1)	
				this.columnData.splice(this.taskBeingDragged.columnIndex, 1, tempData)

				
				

			}
			
			// Get data for the destination column.
			let tempData = this.columnData[index]

			// If the origin and destination columns are the same, remove the item from its current row
			if(index == this.taskBeingDragged.columnIndex) {
				tempData.data.splice(this.taskBeingDragged.rowIndex, 1)

				
				
				

			}
			
			// Determine its stack rank

			let lowerIndex = this.lastTaskDraggedOver.rowIndex - 1
			let lowerRank = 0
			
			if(lowerIndex >= 0) {
				lowerRank = tempData.data[lowerIndex].stackRank
			}
			
			let upperIndex = this.lastTaskDraggedOver.rowIndex
			let upperRank = 0
			
			if(upperIndex < tempData.data.length) {
				upperRank = tempData.data[upperIndex].stackRank
			}

			let currentRank = 0
			
			if(lowerRank == 0 && upperRank == 0) {
				// First item in the column, no harm in keeping its current rank.
				currentRank = this.taskBeingDragged.task.stackRank
			} else if(lowerRank == 0 && upperRank > 0) {
				// Top of the list (i.e. nothing previous), base calc. solely on upperRank
				currentRank = upperRank - 100
			} else if(lowerRank > 0 && upperRank == 0) {
				// Bottom of the list (i.e. nothing next), base calc. solely on lowerRank
				currentRank = lowerRank + 100
			} else {
				// Somewhere with tasks above and below, base calc. on both.
				currentRank = lowerRank + Math.round((upperRank - lowerRank)/2)
			}
			
			
			console.log(lowerIndex + ' --> ' + upperIndex)
			console.log(lowerRank + " --> " + currentRank + ' --> ' + upperRank)

			// this.taskBeingDragged.task.stackRank = currentRank
			// this.taskBeingDragged.task[this.columnField] = this.columnData[index].item

			let task = this.taskBeingDragged.task
			
			this.$set(task, 'stackRank', currentRank)
			this.$set(task, this.columnField, this.columnData[index].item)

			// Prevent an item's field from being set to "unassigned" - application standard is to use NULL.
			if (this.taskBeingDragged[this.columnField] == 'unassigned') {
				this.taskBeingDragged[this.columnField] = null
			}

			// Insert the item at its new row
			tempData.data.splice(this.lastTaskDraggedOver.rowIndex, 0, task)
			
			// Update the data for the destination column
			this.columnData.splice(index, 1, tempData)

			this.taskBeingDragged = {}
			this.lastTaskDraggedOver = {}

			this.saveTaskEdit2(task)

			this.applySort(this.$store.getters.getUserPrefs.taskSortOrder)

		},
		getAdvancedFilter(valueForFilterColumn) {
			let filter = {}
			filter[this.columnField] = valueForFilterColumn
			return filter
		},
		moveTask(task) {

			

		},
		prepareColumns() {
			
			console.log('TaskDropZone.prepareColumns - Prepping columns for ' + this.columnField)
			
			let tempColumnData = []
			
			if (this.columnField == 'context') {
				tempColumnData = this.$store.getters.getContexts.map((x) => {
					return { name: x.name, item: x.name }
				})

			} else if (this.columnField == 'folder') {
				tempColumnData = this.$store.getters.getFoldersForProfile.map((x) => {
					return { name: x.name, item: x.name }
				})
			} else if (this.columnField == 'priority') {
				tempColumnData = this.validPriorities
			} else if (this.columnField == 'status') {
				tempColumnData = this.validStatuses
			}

			tempColumnData.unshift({name: 'Unassigned', item: 'unassigned'})

			tempColumnData.forEach((x, i) => {
				x.data = []
			})

			this.$set(this, 'columnData', tempColumnData)

		},
		prepareTasks() {
			
			
			this.columnData.forEach((x, i) => {

				this.columnMap[x.item] = i

			})

			let maxStackRank = 0

			this.columnData.forEach((x, i) => {
				x.data = []
			})

			this.localTasks.forEach((x, i) => {

				if(typeof x.stackRank == 'undefined' || x.stackRank === null) {
					
					maxStackRank = maxStackRank + 10000
					
					x.stackRank = maxStackRank
				}
				
				let columnIndex = 0
				
				if(typeof x[this.columnField] == 'undefined' || x[this.columnField] == null) {
					columnIndex = 0
				} else {
					columnIndex = this.columnMap[x[this.columnField]]
				}

				// Handle the case where data is out of sync and the column value no longer exists in the list of valid values.
				if(typeof columnIndex == 'undefined' || columnIndex === null) {
					columnIndex = 0
				}

				this.columnData[columnIndex].data.push(x)

			})
		}
	},
}
</script>

<style scoped>
.kanban-odd {
	background-color: lightgray;
}
.kanban-even {
	background-color: white;
}
.kanban-details {
	height: calc(100vh - 375pt);
	overflow-y: auto;
}
</style>
